@if (expanded()) {
  <vl-chips [size]="size()" [contentHeight]="size() === 'small'" [iconRight]="'expand_less'" [state]="expandedState()"
            (action)="expand.emit(false); expanded.set(false)">
    @if (label()) {
      {{ label() }}
    }
  </vl-chips>
} @else {
  <vl-chips [size]="size()" [contentHeight]="size() === 'small'" [iconRight]="'expand_more'" [state]="expandedState()"
            (action)="expand.emit(true); expanded.set(true)">
    @if (label()) {
      {{ label() }}
    }
  </vl-chips>
}
